module.exports = __webpack_public_path__ + "static/media/startericon.35977add.svg";